import './UserPanel.css';
import { getAuth } from "firebase/auth";
import MailVerifyInfo from './MailVerifyInfo/MailVerifyInfo';
import CompanyView from './CompanyView/CompanyView';

const UserPanel = ({setCountryFilterCode, UserLogo, setUserLogo, refresh, setRefresh}) => {

  const authedUser = getAuth() //authedUser.currentUser

  const showUserDetails = () => {

      return <CompanyView 
                refresh={refresh}
                setUserLogo={setUserLogo}
                UserLogo={UserLogo}
                setCountryFilterCode={setCountryFilterCode}
                setRefresh={setRefresh} 
                />
};
    return (// GŁÓWNY RETURN
       <div id='LogedUserAuthDiv'>
           {authedUser.currentUser && authedUser.currentUser.emailVerified ? showUserDetails() : <MailVerifyInfo authedUser={authedUser}/>}
       </div>
    )
};

export default UserPanel;
